<template>
	<div class="cloud-loader">
		<div class="cloud-loader-content">
			<ProntoCloudIcon :animate="animate" />
			<ProntoCloudShadowIcon class="shadow" />
			<IosSpinner v-if="!hideSpinner" />
			<slot />
		</div>
	</div>
</template>

<script>
import IosSpinner from '../IosSpinner'
import { ProntoCloudIcon, ProntoCloudShadowIcon } from '@/icons'

export default {
	name: 'CloudLoader',
	components: { ProntoCloudIcon, ProntoCloudShadowIcon, IosSpinner },
	props: {
		animate: { type: Boolean, default: null },
		hideSpinner: { type: Boolean, default: null },
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.cloud-loader {
	@import 'src/sass/variables';
	@include flex-center;
	background: var(--neutral-0);
	.cloud-loader-content {
		@include flex-column;
		align-items: center;
		.shadow {
			margin: 24px 0;
			font-size: 203px;
			height: 15px;
			color: #e8e8e8;
		}
		:deep(.spinner-div) {
			position: static !important;
		}

		:deep(.ios-spinner) {
			background: var(--neutral-0) !important;
			margin-bottom: 8px;
			div {
				background: var(--neutral-600) !important;
			}
		}
	}
}
</style>
<style lang="scss">
@import 'src/sass/variables';
@include overrideScheme('dark') {
	.shadow {
		color: var(--neutral-100) !important;
	}
}
</style>
